import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Event, NavigationStart } from '@angular/router';
import { RoleService } from 'src/app/services/role/role.service';
import { Searchgeneral } from 'src/app/model/searchgeneral.model';
import { NgForm } from '@angular/forms';
// import swal from 'sweetalert';
import { UserService } from 'src/app/services/user/user.service';


@Component({
  selector: 'app-userrole',
  templateUrl: './userrole.component.html',
  styleUrls: ['./userrole.component.css']
})
export class UserroleComponent implements OnInit {

  data:any;
  searchGeneral: Searchgeneral;
  isListLoading: boolean = false;
  companyName:string;
  rowsOnPage: number = 5;
  allRows: number;

  constructor(private router:Router, private route:ActivatedRoute,private roleservice:RoleService, private userService : UserService) {
    this.searchGeneral = new Searchgeneral();

    // get rows number on page load
    this.userService.roleRowsState.subscribe(
      value => {
        if (value < 5) {
          this.rowsOnPage = 5;
        } else {
          this.rowsOnPage = value;
        }
      }
    );
    // remember rows number on page change
    this.router.events.subscribe((event: Event) => {
      debugger;
      if (event instanceof NavigationStart) {
        if (document.getElementById('roleDataList') !== null) {
          this.userService.roleRowsState.next(document.getElementById('roleDataList').getElementsByTagName('tr').length);
        }
      }
    });
   }

  ngOnInit() {
    // this.userService.currentCompany.subscribe(
    //   (data)=>
    //   {
    //     this.companyName=data;
    //     this.getUserRoles();
    //   }
    // )

    this.userService.currentCompany.subscribe(
      (data)=>
      {
        this.companyName="Phronesis";
        this.getUserRoles();
      }
    )

    this.roleservice.roleCalled.subscribe(
      (data)=>
      {
        if(data==true)
        {
          this.searchGeneral = new Searchgeneral();
          this.getUserRoles();
          this.roleservice.roleCalled.next(false);
        }

      }
    )

  }
  getUserRoles(){

    debugger;
    this.isListLoading = true;
    this.roleservice.getRoleList(this.companyName).subscribe(
    data=>{
      //debugger;
      this.isListLoading = false;
      this.data=data;
      console.log(data);
      if (this.data.length===0) {
        alert("No items found");
      }

      this.allRows = this.data.length;
    }

  )
  }

  SubmitSearchListForm(form: NgForm) {
    debugger;
    this.isListLoading = true;
    this.searchGeneral.companyName=this.companyName;
    this.roleservice.SearchRoleList(this.searchGeneral).subscribe(
      (data : any) => {
        this.isListLoading = false;

        this.data = data;
        if (this.data.length===0) {
          alert("No items found");
        }

        this.allRows = this.data.length;
      }
    )
  }

  submitDrawing () {
    //alert(id);
    this.router.navigate(['/editvendoruser/']);
    //this.router.navigate(['/submitdrawing/' + id + '']);
  }
  //  editrole(){
  //    this.router.navigate(['/userroleassignment']);

  //  }  original code

   editrole(id:number){
    debugger;
    this.router.navigate(['/editrole/'+id]);

  }



  createrole(){
    this.router.navigate(['/userroleassignment']);

  }
  addrole(id:number){
   // swal("hhh")
    this.router.navigate(['/viewrole/'+id]);

  }

}
